import React from "react";

const InputContainer = ({
  sign_up,
  user,
  onEmailSignIn,
  onEmailSignUp,
  onInputChange,
  onForgetPassword
}) => {
  return (
    <div className="email-container">
      {sign_up && (
        <input
          name="name"
          type="text"
          value={user.name}
          className="input-div"
          placeholder="Name"
          onChange={(e) => onInputChange(e.target.value, e.target.name)}
        />
      )}
      <input
        name="email"
        type="email"
        value={user.email}
        className="input-div"
        placeholder="Email"
        onChange={(e) => onInputChange(e.target.value, e.target.name)}
      />
      <input
        name="password"
        type="password"
        value={user.password}
        className="input-div"
        placeholder="Password"
        onChange={(e) => onInputChange(e.target.value, e.target.name)}
      />
      {!sign_up && (
        <span className="forgot-text" onClick={onForgetPassword}>
          Forgot Password?
        </span>
      )}
      <button
        className="onboarding-button"
        onClick={sign_up ? onEmailSignUp : onEmailSignIn}
      >
        Continue
      </button>
    </div>
  );
};

export default InputContainer;
